import * as React from 'react';
import AsyncSelect from 'react-select/async';
import { Stack } from '@fluentui/react';
import { customStyles, invalidCustomStyles } from '../../shared/styles';

const CustomDropbox = ({
	title,
	fieldInfo,
	invalid,
	currentOfficeTheme,
	headerTextStyle,
	dropBoxStyles,
	onChange,
	onLoadOptions,
	...props
}) => {
	const [options, setOptions] = React.useState([]);
	const [isFocused, setIsFocused] = React.useState(false);
	const [isOpotionsLoading, setIsOptionsLoading] = React.useState(false);

	// Used to load dropbox options
	const handleLoadOptions = React.useCallback(
		async (searchOption = '') => {
			// We won't move ahead if user searches in input
			setIsOptionsLoading(true);
			if (searchOption) {
				const result = await handleSearch(searchOption);
				setIsOptionsLoading(false);
				setOptions(result);
				return result;
			}

			// Fetching Data from DB
			try {
				let loadedOptions = await onLoadOptions(fieldInfo);

				setOptions(loadedOptions);
				setIsOptionsLoading(false);
				return loadedOptions;
			} catch (error) {
				console.log('CustomDropbox handleLoadOptions() Error', error);
				setIsOptionsLoading(false);
				return [];
			}
		},
		[fieldInfo],
	);

	// Made it as a promise because
	// Drop down only accepts dropdowns
	const handleSearch = async search => {
		const optns = options.filter(e => e.label.includes(search.toLowerCase()));
		setOptions(optns);
		return optns;
	};

	const handleMenuOpen = () => {
		setIsFocused(true);
	};

	return (
		<Stack>
			<label aria-label={title} style={headerTextStyle} htmlFor={fieldInfo.name}>
				{title}
				{fieldInfo.isRequired && <strong style={{ fontSize: 13, marginTop: '-80%' }}>*</strong>}
			</label>
			<AsyncSelect
				value={isFocused ? '' : fieldInfo?.value || ''}
				defaultOptions={options.length ? options : true}
				placeholder={`Please select a ${title}`}
				label={title}
				name={fieldInfo.name}
				aria-label={`Please select a ${title}`}
				isSearchable
				required={fieldInfo.isRequired}
				isLoading={isOpotionsLoading}
				components={() => <span className="material-symbols-outlined">arrow_drop_down</span>}
				onBlur={() => setIsFocused(false)}
				loadOptions={handleLoadOptions}
				onMenuOpen={handleMenuOpen}
				onChange={(data, event) => {
					onChange(event.name, data);
					setIsFocused(false);
				}}
				onInputChange={(val, e) => {
					if (e.action === 'input-change' && !val) handleLoadOptions(val);
				}}
				style={dropBoxStyles}
				styles={invalid ? invalidCustomStyles(currentOfficeTheme) : customStyles(currentOfficeTheme)}
				{...props}
			/>
		</Stack>
	);
};

export default React.memo(CustomDropbox);
